var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-wrap justify-content-center gap-2 services"},_vm._l((_vm.rowData.services),function(service){return _c('b-badge',{key:service,attrs:{"variant":"primary"}},[_vm._v(" "+_vm._s(service)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }